<!-- 
  Mobile Nav Menu:
  This menu reacts to updates to the global store state.
-->

<template>
  <nav class="site-mobile-nav" style-max-size="medium" v-bind:class="{ 'is-active': state.mobileNavActive }">
      <div class="inner">
          <ul>
              <!-- Yeild to any contents of the component tag -->
              <slot></slot>
          </ul>
      </div>
  </nav>
</template>

<script>
  export default {
    name: 'MobileNavMenu',
    data(){
      // Get the global store state
      return {
        state: store.state,
      }
    },
    mounted: function mounted() {
      // Add an event listener to disable the mobile nav on resize
      this.$nextTick(function () {
        window.addEventListener('resize', window.store.disableMobileNav.bind(window.store), false);
      });
    },
    beforeDestroy: function beforeDestroy() {
      // Before removing the element, remove the resize listener as well.
      window.removeEventListener('resize', window.store.disableMobileNav.bind(window.store), false);
    }
  }
</script>